
import React from "react";
import { Box, Text } from "@chakra-ui/react";

/* ============================================================
   COMPANY LIST
============================================================ */

const companies = [
  "TCS",
  "INFOSYS",
  "WIPRO",
  "COGNIZANT",
  "ACCENTURE",
  "CAPGEMINI",
  "HCL",
  "TECH MAHINDRA",
  "LTIMINDTREE",
  "MPHASIS",
  "HEXAWARE",
  "ZENSAR",
  "IBM",
  "DELOITTE",
  "UST",
  "NTT DATA",
  "DXC",
  "ZOHO",
  "SASKEN",
];

/* ============================================================
   STYLES (Gradient + Smooth Animation)
============================================================ */

const Styles = () => (
  <style>{`
    @keyframes marquee {
      0% { transform: translateX(0%); }
      100% { transform: translateX(-50%); }
    }

    @keyframes gradientFlow {
      0% { background-position: 0% 50%; }
      100% { background-position: 200% 50%; }
    }

    .marquee {
      display: flex;
      width: max-content;
      animation: marquee 28s linear infinite;
    }

    .marquee:hover {
      animation-play-state: paused;
    }

    .gradient-text {
      background: linear-gradient(
        90deg,
        #94a3b8,
        #e2e8f0,
        #028EC4,
        #e2e8f0,
        #94a3b8
      );
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: gradientFlow 6s linear infinite;
    }
  `}</style>
);

/* ============================================================
   COMPONENT
============================================================ */

const Companiesslider = () => {
  const doubled = [...companies, ...companies];

  return (
    <>
      <Styles />

      <Box overflow="hidden" py={{ base: 6, md: 10 }}>
        <div className="marquee">
          {doubled.map((name, i) => (
            <Text
              key={i}
              fontFamily="Bricolage Grotesque"
              mx={{ base: 6, md: 10 }}
              fontSize={{ base: "2xl", md: "5xl", lg: "6xl" }}
              fontWeight="900"
              letterSpacing="0.15em"
              className="gradient-text"
              whiteSpace="nowrap"
            >
              {name}
            </Text>
          ))}
        </div>
      </Box>
    </>
  );
};

export default Companiesslider;
